import { useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { getOperationsVariables } from "./palette";

export default function OperationsTheme({ children }) {
  const portalTheme = useTheme();
  const mode = portalTheme.palette.mode;
  const variables = useMemo(() => getOperationsVariables(mode), [mode]);
  const theme = useMemo(
    () =>
      createTheme(portalTheme, {
        components: {
          // Os portais do MUI saem da árvore DOM da página; precisam receber as mesmas
          // variáveis para tabelas e componentes CSS dentro de diálogos e menus.
          MuiDialog: {
            styleOverrides: { root: { ...variables, colorScheme: mode } },
          },
          MuiPopover: {
            styleOverrides: { root: { ...variables, colorScheme: mode } },
          },
        },
      }),
    [portalTheme, variables, mode],
  );

  return (
    <ThemeProvider theme={theme}>
      <div
        data-operations-theme={mode}
        style={{ ...variables, colorScheme: mode }}
      >
        {children}
      </div>
    </ThemeProvider>
  );
}
